import type { ParameterData } from '@/core/types/library.type'
import { formatTypeUsage } from '@/core/utils/mappers/formatTypeUsage'
import { safeString } from '@/core/utils/mappers/safeString'

type ParameterLike = Partial<ParameterData> & {
  payload?: unknown[]
  type?: unknown
  name?: unknown
}

export const normalizeConstructorParameter = (parameter: ParameterLike): ParameterData => {
  const rawType = parameter.payload?.[0] ?? parameter.type
  const rawName = parameter.payload?.[1] ?? parameter.name

  return {
    name: safeString(rawName),
    type:
      rawType && typeof rawType === 'object' && Array.isArray((rawType as { payload?: unknown[] }).payload)
        ? formatTypeUsage(rawType as { payload: unknown[] })
        : safeString(rawType),
    isNullable: parameter.isNullable,
    isNullabel: parameter.isNullabel,
    primitiveType: parameter.primitiveType,
  }
}
